<template>
  <v-sheet
    color="grey lighten-4"
    class="rounded-lg pa-3 mt-3 mb-4 p-included-events"
  >
    <table v-if="includedEvents.length">
      <tr
        v-for="event of includedEvents"
        :key="event.id"
      >
        <td>{{ dateTimeHelper.utcToLocalDisplayDateFormat(event.start) }}</td>
        <td>{{ event.title }}</td>
        <td>{{ (eventCategoryById(event.categoryId) || {}).name }}</td>
        <td>{{ event.location }}</td>
        <td>{{ getVenueStatusById(event.statusId).name }}</td>
      </tr>
    </table>
    <div v-else class="p-included-events p-included-events--emty-text">
      {{ $t('socialMediaPost.edit.includedEvents_emptyListText') }}
    </div>
  </v-sheet>
</template>


<script>
import { mapGetters } from 'vuex'

import { venueStatus } from '@/constants'

import dateTimeHelper from '@/helpers/dateTime.helper'

import venueStatusMixin from '@/mixins/venueStatus.mixin'


export default {
  mixins: [
    venueStatusMixin
  ],


  data () {
    return {
      dateTimeHelper
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId']),
    ...mapGetters('event', ['eventsByProject']),
    ...mapGetters('eventCategory', ['eventCategoryById']),

    includedEvents () {
      const includedStatuses = [venueStatus.ok, venueStatus.cancelled]

      return this.eventsByProject(this.currentProjectId).filter(event =>
        event.isPromoter === true && includedStatuses.includes(event.statusId))
    }
  }
}
</script>
